var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDecolarGrayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_231_23",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 31,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0024 3.00061H33.003V33.0012H3.0024V3.00061Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_231_23)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.952 32.9994H17.6922C18.342 32.9994 18.9828 32.9598 19.6128 32.8824C27.162 31.9572 33.003 25.6464 33.003 18C33.003 10.3536 27.162 4.04281 19.611 3.11761C18.9744 3.03947 18.3336 3.0004 17.6922 3.00061H11.9502C12.8054 3.49671 13.6182 4.06264 14.3802 4.69261C17.8794 7.59601 20.439 12.0366 20.439 18C20.439 23.9634 17.8794 28.404 14.3802 31.3056C13.6183 31.9363 12.8055 32.5028 11.9502 32.9994H11.952ZM3.0024 32.9994C3.7998 32.9994 4.6404 32.922 5.5026 32.7654C11.295 31.7034 17.9388 27.0126 17.9388 18C17.9388 8.98741 11.295 4.29841 5.5008 3.23641C4.6768 3.08272 3.8406 3.0038 3.0024 3.00061V32.9994Z",
    fill: "#FBFDFD"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecolarGrayIcon);
export default __webpack_public_path__ + "static/media/decolar-gray-icon.771cdf2aab8182ba207ee1c240a272b0.svg";
export { ForwardRef as ReactComponent };